import { Divider, Paper, Stack, Typography } from '@mui/material';
import AlgorithmsTable from './AlgorithmsTable/AlgorithmsTable';
import { Trans } from 'react-i18next';

const Algorithms = (): JSX.Element => {
  return (
    <Paper elevation={2} sx={{ px: 2, py: 2 }}>
      <Stack direction={'column'} spacing={1}>
        <Typography variant={'h4'}>
          <Trans>Algorithms</Trans>
        </Typography>
        <Divider />
        <AlgorithmsTable />
      </Stack>
    </Paper>
  );
};

export default Algorithms;
